import { observable } from 'mobx';
import * as appBrand from '../config/app-brand-config.json';

class CommonStore {
  @observable appName = appBrand.appName;
}

export default new CommonStore();